import { Observable } from "rxjs";
import { ITokenPair } from "../features/auth/interface/dto/token-pair";
import { post } from "./api";

export const updateTrackList = (
    listId: number,
    track: boolean,
    tokens: ITokenPair,
): Observable<boolean> =>
    post<boolean>(`/lists/track/${listId}`, { track }, undefined, tokens);
